import { useState } from "react";
import { Button, Card, CardBody, CardHeader, Badge, Field, TextInput, VerificationBadge } from "@odingard/design-system";
import { EmptyState, ErrorState, LoadingState } from "@odingard/design-system";
import { useAuth } from "../../lib/auth";
import { useAsync } from "../../lib/useAsync";
import { proposalApi } from "../../lib/api";
import { DemoModeBanner, LiveModeBadge } from "../../components/ProposalGrounded";

export function PaiCompliance() {
  const { activeOrg } = useAuth();
  const orgId = activeOrg?.id ?? "";
  const [solicitationId, setSolicitationId] = useState("");
  const [active, setActive] = useState("");
  const state = useAsync(
    async () => (active ? proposalApi.complianceMatrix(orgId, active) : Promise.resolve(null)),
    [orgId, active],
  );
  const m = state.data?.data;

  return (
    <>
      <div className="page-head">
        <div>
          <h1>Compliance Center</h1>
          <p>Requirement to response coverage, grounded and verifiable by a human.</p>
        </div>
      </div>

      <DemoModeBanner show={state.data?.demoMode ?? false} />
      <div style={{ marginBottom: "var(--ods-space-3)" }}>
        <LiveModeBadge demoMode={state.data?.demoMode ?? false} />
      </div>

      <Card>
        <CardHeader title="Load compliance matrix" />
        <CardBody>
          <div className="ods-row" style={{ alignItems: "flex-end", gap: "var(--ods-space-3)" }}>
            <div style={{ flex: 1 }}>
              <Field label="Solicitation ID">
                {(id) => <TextInput id={id} value={solicitationId} onChange={(e) => setSolicitationId(e.target.value)} />}
              </Field>
            </div>
            <Button size="sm" onClick={() => setActive(solicitationId.trim())}>Load</Button>
          </div>
        </CardBody>
      </Card>

      {active && state.loading && <LoadingState label="Loading compliance matrix…" />}
      {state.error && <ErrorState description={state.error.message} onRetry={state.reload} />}
      {m && m.rows.length === 0 && (
        <EmptyState
          title="No requirements yet"
          description="Process the solicitation to shred requirements into a compliance matrix."
        />
      )}
      {m && m.rows.length > 0 && (
        <Card>
          <CardHeader title={`Compliance matrix · ${m.rows.length} requirements`} />
          <CardBody>
            <div className="ods-stack">
              {m.rows.map((r) => (
                <div key={r.id} style={{ padding: "10px 0", borderBottom: "1px solid var(--ods-color-line)" }}>
                  <div className="ods-row" style={{ justifyContent: "space-between", flexWrap: "wrap", gap: "var(--ods-space-2)" }}>
                    <div style={{ fontWeight: 600 }}>
                      <Badge tone="neutral">§{r.sourceSection || r.requirementType}</Badge> {r.identifier}
                    </div>
                    <div className="ods-row" style={{ gap: "var(--ods-space-2)" }}>
                      <Badge tone={r.coverageStatus === "covered" ? "success" : "warning"}>{r.coverageStatus}</Badge>
                      <Badge tone={r.criticality === "high" ? "warning" : "neutral"}>{r.criticality}</Badge>
                      <VerificationBadge state={r.verificationState} />
                    </div>
                  </div>
                  <p style={{ margin: "6px 0 0", color: "var(--ods-color-muted)" }}>{r.requirementText}</p>
                </div>
              ))}
            </div>
          </CardBody>
        </Card>
      )}
    </>
  );
}
